import { ComponentProps } from 'react'
import styles from './styles.module.scss'

const Addon = ({ className, ...props }: ComponentProps<'div'>) => (
  <div {...props} className={[styles.addon, className].join(' ')} />
)

export default Addon
